import Vue from 'vue'
import Router from 'vue-router'
import TheIng from '@/components/TheIng'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'TheIng',
      component: TheIng
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js